import { QUERY_CURRENT_CHANNEL } from '~/app/state/queries'
import { setCachedData } from '~/shared/utils'

/**
 *
 */
export default async function setCurrentChannel(
  // @ts-expect-error TS(7006) FIXME: Parameter '_' implicitly has an 'any' type.
  _,
  // @ts-expect-error TS(7031) FIXME: Binding element 'currentChannel' implicitly has an... Remove this comment to see the full error message
  { currentChannel },
  // @ts-expect-error TS(7031) FIXME: Binding element 'client' implicitly has an 'any' t... Remove this comment to see the full error message
  { client },
) {
  setCachedData(client, {
    query: QUERY_CURRENT_CHANNEL,
    data: { currentChannel },
  })
}
